/*
 * @Author: Gaho
 * @Date: 2024-03-13 10:27:03
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 11:38:14
 * @Description: 
 */
import img0 from '@/assets/imgs/triple/0.webp';
import img1 from '@/assets/imgs/triple/1.webp';
import img2 from '@/assets/imgs/triple/2.webp';
/**
 * 获取图标地址
 */
export const getImageUrl = (name: string) => {
    const imgs = [img0, img1, img2];
    return imgs[name];
}